export const PERIODS = {
  THREE_YEAR: '3 Year',
  FIVE_YEAR: '5 Year',
  TEN_YEAR: '10 Year',
} as const;

export const Constants = {
  TAG_NAME: 'pop-risk-component',
  COMPONENT_TITLE: 'Risk measures',
  AS_OF_DATE_PREFIX: 'based on composite gross returns as of',
  RISK_BENCHMARK: 'risk-benchmark',
  RISK_CONTENT: 'risk-content',
  RISK_HEADING: 'risk-heading',
  RISK_MIDDLE_SECTION: 'risk-middle-section',
  RISK_UNAVAILABLE: 'Risk measures unavailable',
  PERIOD_DROPDOWN_HEADER_LABEL: 'View',
  PERIOD_NO_DROPDOWN_PREFIX_LABEL: 'Showing',
  PERIOD_NO_DROPDOWN_POSTFIX_LABEL: 'risk',
  PERIOD_SELECT: 'period-select',
  PERIODS: [PERIODS.THREE_YEAR, PERIODS.FIVE_YEAR, PERIODS.TEN_YEAR],
  DEFAULT_PERIOD: PERIODS.THREE_YEAR,
  BENCHMARK_PREFIX: 'Benchmark:',
} as const;
